<template>
    <b-modal id="anular-contrato-modal" size="lg" centered header-bg-variant="secondary" header-text-variant="light" @hidden="$emit('fecharModal')"
        :title="`Anular Contrato`" hide-footer>
        <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(anularContrato)">
                <h6 class="mb-3 text-left">
                    <b-button v-if="!formDesabilitado" class="float-right m-1" size="sm" type="submit">
                        <font-awesome-icon icon="save" />
                        Anular Contrato
                    </b-button>
                    <b-button v-else class="float-right m-1" size="sm" @click="desfazerAnulacao">
                        <font-awesome-icon icon="times" class="mr-1" />
                        Desfazer Anulação
                    </b-button>
                </h6>
                <b-row class="w-100">
                    <b-col cols="12">
                        <default-form-validation-provider label="Data da Anulação" v-slot="defaultState">
                            <b-form-datepicker id="input-data-anulacao" :state="defaultState.state" :disabled="formDesabilitado"
                                v-model="contrato.DtAnulacao" v-bind="datePickerProps">
                            </b-form-datepicker>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12">
                        <default-form-validation-provider label="Motivo da Anulação" v-slot="defaultState" rules="max:500">
                            <b-form-textarea id="input-motivo-anulacao" :state="defaultState.state" :disabled="formDesabilitado"
                                v-model="contrato.DeMotivoAnulacao" rows="3" max-rows="6"></b-form-textarea>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="6">
                        <default-form-validation-provider v-if="tipoArquivo === 'salvo'"
                            label="Arquivo Texto da Anulação do Contrato (PDF)" rules="">
                            <span v-if="contrato && contrato.ArquivoAnulacao">Nome: {{
                                contrato.ArquivoAnulacao.DeNomeArquivo }}</span>
                            <div class="d-flex justify-content-center">
                                <btn-download class="mr-2" :fazerDownload="baixarAnexo"
                                    :parametros="contrato.ArquivoAnulacao" texto="" />
                            </div>
                        </default-form-validation-provider>
                        <default-form-validation-provider v-else label="Arquivo Texto da Anulação do Contrato (PDF)"
                            v-slot="defaultState">
                            <b-form-file v-model="contrato.ArquivoAnulacao" placeholder="Nenhum arquivo selecionado"
                                accept="application/pdf" :state="defaultState.state"></b-form-file>
                        </default-form-validation-provider>
                    </b-col>
                </b-row>
        </b-form>
    </validation-observer>
    </b-modal>
</template>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { ValidationObserver } from "vee-validate"
import BtnDownload from '@/components/shared/btn-download.vue'
import { DatePickerDefaultProps, FormGroupDefaultCols } from '@/types/form-default-props'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import contratoService from '@/services/licitacoes/contratoService'
import { Contrato } from '@/types/licitacoes/contratos/contrato'
import { ArquivoContrato } from '@/types/licitacoes/contratos/arquivo-contrato'

const CompProps = Vue.extend({
    name: 'ModalAnularContrato',
    components: { 
                  BtnDownload, DefaultFormValidationProvider, ValidationObserver
                },
    props: {
        idContrato: {
            type: String,
            default: ''
        }
    },
})

@Component
export default class ModalAnularContrato extends mixins(UtilsTS, CompProps) {
    @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
    datePickerProps = DatePickerDefaultProps
    formGroupCols = FormGroupDefaultCols
    contrato: Contrato = new Contrato()
    tipoArquivo: string | null = null
    showForm = false
    formDesabilitado = false

    async anularContrato(): Promise<void> {
        store.blockScreen = true
        try {
            const isValid = await this.validationobserver.validate();
            if (!isValid) {
                console.error(this.validationobserver)
            } else {
                //salvar o contrato 
                const retorno = await contratoService.anular(this.contrato)
                if(retorno) {
                    this.$emit('refresh')
                    this.$emit('fecharModal')
                    this.$toast.success(`O contrato foi anulado!`)
                }
            }
        } catch (e: any) {
            this.tratarError(e, true)
        } finally {
            store.blockScreen = false
        }
    }

    async desfazerAnulacao(): Promise<void> {
        store.blockScreen = true
        try {
            const retorno = await contratoService.desfazerAnulacao(this.contrato.IdContrato)
            if(retorno) {
                this.$emit('refresh')
                this.$emit('fecharModal')
                this.$toast.success(`O contrato foi atualizado!`)
            }
        } catch (e: any) {
            this.tratarError(e, true)
        } finally {
            store.blockScreen = false
        }
    }

    async baixarAnexo(arquivo: ArquivoContrato) {
        const response = await contratoService.baixarAnexo(String(arquivo.IdArquivo))
        this.download(`anulacao-${this.contrato.NumeroAnoContrato}`, response.data)
    }
    removerArquivoAnulacao() {
        this.contrato.ArquivoAnulacao = undefined
        this.tipoArquivo = this.contrato.getTipoArquivo('anulacao')
    }
    async mounted() {
        try {
            store.blockScreen = true
            if (this.idContrato.length > 0) {
                this.contrato = await contratoService.buscarDadosGerais(this.idContrato)
                this.contrato.tratarDadosDaAPI()
                this.formDesabilitado = this.contrato.CdSituacao === "AN" || this.contrato.DtAnulacao !== null
                this.tipoArquivo = this.contrato.getTipoArquivo('anulacao')
                this.$bvModal.show("anular-contrato-modal");
            }
        }
        catch (e: unknown) {
            console.error('Erro ao carregar modal de anulação de contrato', e)
        } finally {
            this.showForm = true
            store.blockScreen = false
        }
    }
}


</script>

<style>
</style>